// Entity Types for different moderation tabs
export const MODERATION_ENTITIES = {
  PENDING_USERS: 'pendingUsers',      // Pending approval requests
  APPROVED_USERS: 'approvedUsers',    // Approved users
  REJECTED_USERS: 'rejectedUsers',    // Rejected users
  REPORTS: 'reports',                 // Reports
};

// Action Types
export const MODERATION_ACTION_TYPES = {
  // Generic list actions
  FETCH_MODERATION_LIST: 'FETCH_MODERATION_LIST',
  FETCH_MODERATION_LIST_SUCCESS: 'FETCH_MODERATION_LIST_SUCCESS',
  FETCH_MODERATION_LIST_FAILURE: 'FETCH_MODERATION_LIST_FAILURE',

  // User approval specific actions
  APPROVE_USER_REQUEST: 'APPROVE_USER_REQUEST',
  APPROVE_USER_SUCCESS: 'APPROVE_USER_SUCCESS',
  APPROVE_USER_FAILURE: 'APPROVE_USER_FAILURE',

  REJECT_USER_REQUEST: 'REJECT_USER_REQUEST',
  REJECT_USER_SUCCESS: 'REJECT_USER_SUCCESS',
  REJECT_USER_FAILURE: 'REJECT_USER_FAILURE',

  // Employee assignment
  ASSIGN_EMPLOYEE_TO_USER: 'ASSIGN_EMPLOYEE_TO_USER',
  ASSIGN_EMPLOYEE_SUCCESS: 'ASSIGN_EMPLOYEE_SUCCESS',
  ASSIGN_EMPLOYEE_FAILURE: 'ASSIGN_EMPLOYEE_FAILURE',

  // UI state actions
  SET_ACTIVE_MODERATION_TAB: 'SET_ACTIVE_MODERATION_TAB',
  SET_MODERATION_FILTERS: 'SET_MODERATION_FILTERS',
  RESET_MODERATION_STATE: 'RESET_MODERATION_STATE',

  // Employee list for assignment
  FETCH_EMPLOYEES_LIST: 'FETCH_EMPLOYEES_LIST',
  FETCH_EMPLOYEES_LIST_SUCCESS: 'FETCH_EMPLOYEES_LIST_SUCCESS',
  FETCH_EMPLOYEES_LIST_FAILURE: 'FETCH_EMPLOYEES_LIST_FAILURE',

  // Dynamic row updates
  UPDATE_MODERATION_ROW: 'UPDATE_MODERATION_ROW',
  UPDATE_MODERATION_ROW_SUCCESS: 'UPDATE_MODERATION_ROW_SUCCESS',
  UPDATE_MODERATION_ROW_FAILURE: 'UPDATE_MODERATION_ROW_FAILURE',

  // Real-time updates
  REAL_TIME_UPDATE_ROW: 'REAL_TIME_UPDATE_ROW',
  VALUE_APPENT_IN_ARRAY:'VALUE_APPENT_IN_ARRAY',
  REPORT_MODERATION_LOADER:'REPORT_MODERATION_LOADER',
  REPORT_MODERATION_LIST:'REPORT_MODERATION_LIST'
};
